import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import TopicForm from "../../../components/TopicForm";
import { Card, Col, Row, Spin } from "antd";

const EditView = (props: any) => {
    const { topic, onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Topics", link: "/book/topic" },
                { name: "Edit", link: "" },
                { name: topic?.name, link: "" },
            ]}
        >
            <MetaTag title="Add Topic" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Topic Update"}
                        bordered={true}
                    >
                        {topic && (
                            <TopicForm
                                topic={topic}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
